import React from 'react';

import { useImmer } from 'use-immer';

import { useAppSelector } from '_lib/redux/hooks';

import {
  BaseCompanyZoneZipSelect,
  createZoneZipSelectState,
  ZoneZipSelectState
} from '../../../../../common/CompanyPane/CompanySelected/BaseCompanyZipZoneSelect';
import { ZipZoneSelectComponentProps } from '../../../../../common/CompanyPane/CompanySelected/zipZoneSelectContext';
import { selectPhoneCallContext } from '../../../PoolBrainPhoneCall.slice';

export const CompanyZoneZipSelect = (props: ZipZoneSelectComponentProps): React.ReactElement => {
  const phoneCallContext = useAppSelector(selectPhoneCallContext);
  const [zoneZipSelectState, setZoneZipSelectState] = useImmer<ZoneZipSelectState>(createZoneZipSelectState());
  return (
    <BaseCompanyZoneZipSelect
      externalZipOrPostal={phoneCallContext.customerLocation?.zipOrPostal}
      zoneZipSelectState={zoneZipSelectState}
      setZoneZipSelectState={setZoneZipSelectState}
      {...props}
    />
  );
};
